import { observer } from "mobx-react";
import React from "react";
import { L10nHtml } from "@fidget/common/i18n";
import { WelcomeToHeader } from "../../components/beforeLogin/components/welcomeToHeader";
import { AcceptInvitation } from "../../components/beforeLogin/signup/acceptInvitation";
import { AdminSignUpController } from "../../components/beforeLogin/signup/adminSignUpController";
import { AdminSignUpStart } from "../../components/beforeLogin/signup/adminSignUpStart";
import { getGtmService } from "../../services/gtmService";
import styles from "./signUp.css";

export enum SignUpView {
  ACCEPT_INVITATION,
  ORG_SIGNUP,
  ORG_SIGNUP_DETAILS
}

interface Props {
  view: SignUpView;
}

interface State {
  displayMode: "welcome" | "completingForm";
}

@observer
export class SignUpContainer extends React.Component<Props, State> {
  signupTimeout = 2000;
  private gtmService = getGtmService();

  constructor(props: Props) {
    super(props);
    this.state = {
      displayMode: "welcome"
    };
  }

  componentDidMount() {
    this.gtmService.addGoogleTagManager();
    setTimeout(() => this.setState({ displayMode: "completingForm" }), this.signupTimeout);
  }

  renderContent = () => {
    switch (this.props.view) {
      case SignUpView.ACCEPT_INVITATION:
        return <AcceptInvitation timeout={this.signupTimeout} />;
      case SignUpView.ORG_SIGNUP:
        return <AdminSignUpStart />;
      case SignUpView.ORG_SIGNUP_DETAILS:
        return <AdminSignUpController timeout={this.signupTimeout} />;
      default:
        return <div />;
    }
  };

  render() {
    return (
      <div className={styles["signup-background"]}>
        <WelcomeToHeader timeToAnimate={this.signupTimeout} styleType={"signup"}>
          {this.renderContent()}
        </WelcomeToHeader>
        <footer className={styles.footer}>
          <L10nHtml id={"closer.data"} />
        </footer>
      </div>
    );
  }
}
